import { render, staticRenderFns } from "./ProtocolForm.vue?vue&type=template&id=6bd0ecb7&scoped=true&"
import script from "./ProtocolForm.vue?vue&type=script&lang=js&"
export * from "./ProtocolForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd0ecb7",
  null
  
)

export default component.exports